export { Education } from './Education';
